import { ButtonGroup, H2 } from "@blueprintjs/core"
import styled from "@emotion/styled"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const FieldsContainer = styled(FlexContainer)({
  height: "100%",
  marginTop: "30px",
  overflow: "hidden",
})

type CompanyNameProps = {
  isDirty: boolean
}

/**
 * Highlight in orange CompanyName if user has modified it.
 */
export const CompanyName = styled(H2, {
  shouldForwardProp: prop => prop !== "isDirty",
})<CompanyNameProps>(props => ({
  color: props.isDirty ? `${SCIENT_COLORS.orange5} !important` : "",
  margin: "0 0 0 10px",
  width: "300px",
}))

export const ActionButtonGroup = styled(ButtonGroup)({
  width: "300px !important",
})
